import store from 'Redux/store';

export const RESET_ACCOUNT_CONFIRM = 'frontend/account-confirm/RESET_ACCOUNT_CONFIRM';
export const NEW_STATE_ACCOUNT_CONFIRM = 'frontend/account-confirm/NEW_STATE_ACCOUNT_CONFIRM';

export function newState(statePassed) {
  store.dispatch({ type: NEW_STATE_ACCOUNT_CONFIRM, payload: statePassed });
}
